<template>
  <div>
      <div class="container">
          <p class="box">For me filming is another way to tell a story, but without words. To capture not just a moment of your life, but a full range of emotions. Thus, film-editing helps me to express my creativity and show others how I see this world.</p>
      </div>
      <div class="container grid">
          <div class="video-grid" v-for="item in items" :key="item.id">
                <h1> {{item.name}} </h1>
                <p class="video-box" v-html="item.content.link"></p>
          </div>
      </div>
  </div>
</template>



<script>
const StoryblokClient = require('storyblok-js-client');
const Storyblok = new StoryblokClient({
  accessToken: process.env.VUE_APP_KEY,
  cache: {
    clear: 'auto',
    type: 'memory'
  }
});
export default {
    name: 'video-editing',
    methods: {
    getStories() {
      Storyblok.get('cdn/stories', {
        "starts_with": "portfolio/video/"
      })
      .then(response => {
        this.items = response.data.stories;
      }).catch(error => { 
        console.log(error)
      })
    }
  },
  data: function () {
     return {
        items: []
     }
  },
  mounted() {
    this.getStories();
  }
}
</script>



<style>
.box {
    position: relative;
    display: inline-block;
    width: 50%;
    padding: 100px 0 20px;
}
.video-box {
    width: 900px;
    height: 500px;
    padding-bottom: 30px;
    border-radius: 5px;
    position: relative;
    display: inline-block;
}
iframe {
    width: 100%;
    height: 100%;
}
.video-grid {
    position: relative;
    display: inline-block;
    margin: 0 auto;
}
.video-grid h1 {
    color: #F3A822;
    padding: 50px 0 20px;
}
a {
    color: #020202;
}
a:hover {
    color: #F3A822;
}

@media only screen 
and (min-device-width : 768px) and (max-device-width : 1024px) {
.box {
  width: 75%;
}
.video-grid {
  width: 85%;
  margin: 35px 0 25px;
}
.video-box {
  width: 100%;
  height: 400px;
  padding: 15px 0 10px;
}
}
@media only screen and (max-width: 600px) {
.box {
  width: 75%;
  padding: 50px 0 30px;
}
.video-grid {
  width: 85%;
  margin: 35px 0 25px;
}
.video-grid h1 {
  font-size: 1.7rem;
  padding: 0 0 0;
}
.video-box {
  width: 100%;
  height: 200px;
  padding-top: 15px;
}
}
</style>